import script from "./AddPhotoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPhotoForm.vue?vue&type=script&setup=true&lang=js"

import "./AddPhotoForm.vue?vue&type=style&index=0&id=5933ab7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5933ab7a"]])

export default __exports__